import React, { Dispatch, SetStateAction } from "react";

interface ITimerContext {
    time: [number, number, number],
    setTime: Dispatch<SetStateAction<[number, number, number]>>,
}

export const TimerContext = React.createContext<ITimerContext>({
    time: [0, 0, 0],
    setTime: () => {},
})
